import { LocalizedText, TextKey } from '@mews-framework/localization';
import { PasswordRequirementData, PasswordStrength } from '@optimus-web/core';

const containsNumbers = (str: string) => /[0-9]/.test(str);
const containsLowercaseLetters = (str: string) => /[a-z]/.test(str);
const containsUppercaseLetters = (str: string) => /[A-Z]/.test(str);
const containsSpecialCharacters = (str: string) => /[!@#$%^&*(),.?":{}|<>_-]/.test(str);
const satisfiesMinimumLength = (str: string) => str.length >= MIN_PASSWORD_LENGTH;

export const MAX_PASSWORD_STRENGTH = PasswordStrength.Good;
export const MIN_PASSWORD_LENGTH = 12;

export const passwordRequirements: PasswordRequirementData[] = [
    {
        id: 'contains-numbers',
        validate: containsNumbers,
        label: <LocalizedText textKey={TextKey.ValidatePasswordContainsNumbers} />,
    },
    {
        id: 'contains-lowercase-letters',
        validate: containsLowercaseLetters,
        label: <LocalizedText textKey={TextKey.ValidatePasswordContainsLowercaseLetters} />,
    },
    {
        id: 'contains-uppercase-letters',
        validate: containsUppercaseLetters,
        label: <LocalizedText textKey={TextKey.ValidatePasswordContainsUppercaseLetters} />,
    },
    {
        id: 'contains-special-characters',
        validate: containsSpecialCharacters,
        label: <LocalizedText textKey={TextKey.ValidatePasswordSatifiesSpecialCharacters} />,
    },
    {
        id: 'satisfies-minimum-length',
        validate: satisfiesMinimumLength,
        label: (
            <LocalizedText
                textKey={TextKey.ValidatePasswordSatifiesMinimumLength}
                substitutes={{ minimumPasswordLength: MIN_PASSWORD_LENGTH }}
            />
        ),
    },
];
